class Product {
  constructor(el, opt) {
    this.el = el;
    if($(this.el).length){
      this.event();
    }
  }
  event(){
    // console.log("sss");
    var swiper = new Swiper(".slider1", {
      autoplay: {
        disableOnInteraction: false,
        delay: 4000,
        },
      speed: 600,
      slidesPerView: 2,
      spaceBetween: 20,
      loop: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        // スライドの表示枚数：500px以上の場合
        960: {
          slidesPerView: 4,
        }
      }
    })
    const slideLength = document.querySelectorAll('.slider1 .swiper-slide').length
    if (slideLength < 4) {
      const swiperElm = document.querySelector('.p-product-lineup__list')
      swiperElm.classList.add('active')
    }

    var swiper = new Swiper(".slider2", {
      autoplay: {
        disableOnInteraction: false,
        delay: 4000,
      },
      speed: 600,
      loop: true,
      slidesPerView: 2,
      spaceBetween: 20,
      navigation: {
        nextEl: ".swiper-button-next02.swiper-button-next",
        prevEl: ".swiper-button-prev02.swiper-button-prev",
      },
      breakpoints: {
        // スライドの表示枚数：500px以上の場合
        960: {
          slidesPerView: 4,
        }
      },
    })
    const slideLength2 = document.querySelectorAll('.slider2 .swiper-slide').length
    if (slideLength2 < 4) {
      const swiperElm = document.querySelector('.p-product-lineup__list')
      swiperElm.classList.add('active')
    }

    var swiper = new Swiper(".slider3", {
      autoplay: {
        disableOnInteraction: false,
        delay: 4000,
      },
      speed: 600,
      loop: true,
      slidesPerView: 2,
      spaceBetween: 20,
      navigation: {
        nextEl: ".swiper-button-next03.swiper-button-next",
        prevEl: ".swiper-button-prev03.swiper-button-prev",
      },
      breakpoints: {
        // スライドの表示枚数：500px以上の場合
        960: {
          slidesPerView: 4,
        }
      },
    })
    const slideLength3 = document.querySelectorAll('.slider3 .swiper-slide').length
    if (slideLength3 < 4) {
      const swiperElm = document.querySelector('.p-product-lineup__list')
      swiperElm.classList.add('active')
    }
  }
}
